module.exports = __webpack_public_path__ + "img/Crooked Stone.6e6fa0f3.png";